import { render, staticRenderFns } from "./PaymentTerms.vue?vue&type=template&id=9e28037e&scoped=true"
import script from "./PaymentTerms.vue?vue&type=script&lang=js"
export * from "./PaymentTerms.vue?vue&type=script&lang=js"
import style0 from "./PaymentTerms.vue?vue&type=style&index=0&id=9e28037e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e28037e",
  null
  
)

export default component.exports